<template>
  <div class="sign">
    <!-- 心田花开线下课程 -->
    <div ref="offline" class="offline">
      <div :class="['title', ' animated fadeInUp']">心田花开课程介绍</div>
      <!-- 图标 -->
      <div
        ref="sign_icon"
        :class="['sign-icon container', ' animated fadeInUp']"
      >
        <div
          v-for="(v, i) in signIcon"
          :key="i"
          class="icon-item"
          @click="jump(i)"
        >
          <img
            ref="iconimg"
            :src="bigIcon1[i] || bigIcon2[i] ? signIconLight[i].url : v.url"
            :class="bigIcon1[i] || bigIcon2[i] ? 'big' : 'small'"
            @mouseenter="debounce1('in', i, 100)"
            @mouseout="debounce1('out', i, 100)"
          />
          <span class="name">{{ v.name }}</span>
          <img
            v-show="flag === i"
            class="line"
            src="@/assets/images/line.png"
          />
        </div>
      </div>
      <!-- swiper -->
      <div
        :class="['sing-swiper', animate.offline ? ' animated fadeInUp' : '']"
      >
        <div class="swiper-container sign-container swiper-no-swiping">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <EmotionalLanguage :status="activeIndex" />
            </div>
            <div class="swiper-slide">
              <maths :status="activeIndex" />
            </div>
            <div class="swiper-slide">
              <abc :status="activeIndex" />
            </div>
            <div class="swiper-slide">
              <physical :status="activeIndex" />
            </div>
            <div class="swiper-slide">
              <calligraphy :status="activeIndex" />
            </div>
            <div class="swiper-slide">
              <TraditionalChinese :status="activeIndex" />
            </div>
            <div class="swiper-slide">
              <chemical :status="activeIndex" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 四大课程特色 为孩子成长护航 -->
    <div ref="feature" :class="['feature ']">
      <div class="container">
        <transition enter-active-class="fadeInUp">
          <div v-show="featureS" :class="['title', 'animated']">
            四大课程特色 为孩子成长护航
          </div>
        </transition>
        <transition enter-active-class="fadeInUp">
          <div v-show="featureS" :class="['items', ' animated ']">
            <div v-for="(v, i) in featureList" :key="i" class="item">
              <div class="top">
                <img :src="v.img" alt />
              </div>
              <div class="middle">{{ v.title }}</div>
              <div class="bottom">{{ v.con }}</div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <!-- 应用下载 -->
    <div ref="download" :class="['download']">
      <transition enter-active-class="fadeInUp">
        <div
          v-show="downloadS || queryName != ('' || undefined)"
          :class="['title', ' animated ']"
        >
          应用下载
        </div>
      </transition>
      <div class="con">
        <div class="left">
          <transition enter-active-class="fadeInUp">
            <div
              v-show="downloadS || queryName != ('' || undefined)"
              :class="['tel', ' animated']"
            >
              <div class="panel">
                <TelSwiper />
              </div>
            </div>
          </transition>
        </div>
        <transition enter-active-class="fadeIn">
          <div
            v-show="downloadS || queryName != ('' || undefined)"
            :class="['right', ' animated ']"
          >
            <div class="s-title">心田花开APP</div>
            <div class="desc">
              了解最新教育资讯，报名心田花开线下情商语文、全科教育小班体系课程，请下载【心田花开APP】
            </div>
            <img class="ercode" src="@/assets/images/download.png" alt />
          </div>
        </transition>
      </div>
    </div>
    <!-- 快速报名 -->
    <div ref="fast" :class="['fast']">
      <transition enter-active-class="fadeInUp">
        <div
          v-show="fastS || queryName != ('' || undefined)"
          :class="['title', ' animated']"
        >
          快速报名
        </div>
      </transition>
      <div class="con">
        <transition enter-active-class="fadeIn">
          <div
            v-show="fastS || queryName != ('' || undefined)"
            :class="['right', ' animated']"
          >
            <div class="s-title sign-port">
              报名入口
              <img class="hot" src="@/assets/images/sign-hot.png" alt />
            </div>
            <div class="desc">
              微信扫描下方二维码，即可进入“心田花开面授课程”报名系统，快速查询教学点，报名更快捷
            </div>
            <img class="ercode" src="@/assets/images/sign.png" alt />
          </div>
        </transition>
        <div class="left">
          <transition enter-active-class="fadeInUp">
            <div
              v-show="fastS || queryName != ('' || undefined)"
              :class="['tel', ' animated']"
            >
              <div class="panel">
                <TelSwiper1 />
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <!-- foot -->
    <div v-show="fastS" class="foot">
      <Footer />
    </div>
  </div>
</template>
<script>
import EmotionalLanguage from '@/components/sign/emotional-language.vue'; //情商语文
import abc from '@/components/sign/abc.vue'; //英语
import calligraphy from '@/components/sign/calligraphy.vue'; //书法
import chemical from '@/components/sign/chemical.vue'; //化学
import maths from '@/components/sign/math.vue'; //数学
import physical from '@/components/sign/physical.vue'; //物理
import TraditionalChinese from '@/components/sign/traditional-Chinese.vue'; //国学
import Footer from '@/components/footer.vue';
import TelSwiper from '@/components/tel-swiper.vue'; // 应用下载
import TelSwiper1 from '@/components/tel-swiper1.vue'; // 快速报名
import { Swiper } from 'vue-awesome-swiper';
import { throttle } from '@/utils/throttle.js';
import getPosition from '@/utils/speed';
import { platformDetail } from '@/libs/api';
import test from '@/utils/speed2'; //滑动函数2
let timer = null;
export default {
  components: {
    EmotionalLanguage,
    abc,
    chemical,
    physical,
    calligraphy,
    maths,
    TraditionalChinese,
    Footer,
    TelSwiper,
    TelSwiper1
  },
  data() {
    return {
      platMsg: [],
      mySwiper: {},
      signIcon: [
        { url: require('../assets/images/EQ.png'), name: '语文' },
        { url: require('../assets/images/cube.png'), name: '数学' },
        { url: require('../assets/images/abc.png'), name: '英语' },
        { url: require('../assets/images/physics.png'), name: '物理' },
        { url: require('../assets/images/pen.png'), name: '书法' },
        { url: require('../assets/images/Chinese.png'), name: '国学' },
        { url: require('../assets/images/chemical.png'), name: '化学' }
      ],
      // 高亮图标
      signIconLight: [
        { url: require('../assets/images/EQ-light.png'), name: '语文' },
        { url: require('../assets/images/cube-light.png'), name: '数学' },
        { url: require('../assets/images/abc-light.png'), name: '英语' },
        { url: require('../assets/images/physics-light.png'), name: '物理' },
        { url: require('../assets/images/pen-light.png'), name: '书法' },
        { url: require('../assets/images/Chinese-light.png'), name: '国学' },
        { url: require('../assets/images/chemical-light.png'), name: '化学' }
      ],
      activeIndex: 0,
      featureList: [
        {
          img: require('@/assets/images/teacher-select.png'),
          title: '师资选培',
          // con: '七层严格考核，集结全国一线名师，清华北大优秀师资'
        },
        {
          img: require('@/assets/images/light.png'),
          title: '课程研发',
          // con: '八步锻造，全国一流、权威专业的教研能力'
        },
        {
          img: require('@/assets/images/headset.png'),
          title: '课后服务',
          // con: '全方位护航，在心田花开，每个孩子都是“1对1”'
        },
        {
          img: require('@/assets/images/book.png'),
          title: '春晚式课堂',
          // con: '十二轮打磨，严格把关每一堂课的教学质量'
        }
      ],
      animate: {
        offline: true
      },
      scroll: 0, //滚动条高度
      featureH: 0,
      downloadH: 0,
      fastH: 0,
      flag: 0, //轮播下标
      bigIcon1: [true, false, false, false, false, false, false], //图标变大
      bigIcon2: [true, false, false, false, false, false, false], //图标变大
      // 显示标识
      featureS: false,
      downloadS: false,
      fastS: false,
      queryName: '',
      submenuJump: false, //是否为点击子菜单跳转
      fn: null //防抖函数
    };
  },
  created() {
    this.queryName = this.$route.params.name;
    this.getMsg();
  },
  mounted() {
    this.init();
    window.scrollTo(0, 0);
    this.getTop();
    this.fn = throttle(this.listen, 300);
    window.addEventListener('scroll', this.fn);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.fn);
  },
  methods: {
    getMsg() {
      platformDetail().then(res => {
        this.platMsg = res.data;
        console.log('sidebar:', this.platMsg[9]);
      });
    },
    init() {
      let that = this;
      this.mySwiper = new Swiper('.sign-container', {
        direction: 'horizontal',
        height: 660,
        speed: 300,
        pagination: '.swiper-pagination',
        paginationType: 'bullets',
        on: {
          slideChange: function() {
            console.log('sign', this.activeIndex);
            that.activeIndex = this.activeIndex;
          }
        }
      });
    },
    jump(index) {
      for (let index = 0; index < this.bigIcon1.length; index++) {
        this.$set(this.bigIcon1, index, false);
      }
      event.preventDefault();
      this.flag = index;
      this.$set(this.bigIcon1, index, true);
      this.mySwiper.slideTo(index, 800, false); //切换到第一个slide，速度为1秒
    },
    throttle,
    // debounce,
    // 波浪特效
    debounce1(state, i, wait) {
      if (timer !== null) {
        clearTimeout(timer);
      }
      for (let index = 0; index < this.bigIcon2.length; index++) {
        this.$set(this.bigIcon2, index, false);
      }

      timer = setTimeout(() => {
        state === 'in'
          ? this.$set(this.bigIcon2, i, true)
          : this.$set(this.bigIcon2, i, false);
      }, wait);
    },
    //添加动画
    listen() {
      this.scroll =
        document.documentElement.scrollTop + document.body.scrollTop;
      // var offlineH = this.$refs.offline.offsetTop;
      if (this.scroll < this.featureH + 400) {
        this.$store.commit('setSignSub', 1);
      }
      if (
        this.scroll >= this.featureH - 400 &&
        this.scroll <= this.downloadH + 600
      ) {
        this.$store.commit('setSignSub', 2);
      }
      if (
        this.scroll >= this.featureH - 800 &&
        this.scroll <= this.downloadH - 400
      ) {
        // feature
        this.featureS = true;
      }
      if (this.scroll >= this.downloadH - 800 && this.scroll <= this.fastH) {
        this.$store.commit('setSignSub', 3);
        this.downloadS = true;
      }
      if (this.scroll >= this.fastH - 400) {
        this.$store.commit('setSignSub', 4);
        this.fastS = true;
      }
    },
    getTop() {
      this.featureH = document.getElementsByClassName('feature')[0].offsetTop;
      this.downloadH = document.getElementsByClassName('download')[0].offsetTop;
      this.fastH = document.getElementsByClassName('fast')[0].offsetTop;
      console.log(this.featureH, this.downloadH, this.fastH);
      this.$store.commit('setSignDestinate', {
        featureH: this.featureH,
        downloadH: this.downloadH,
        fastH: this.fastH
      });
      // 子菜单跳转
      let name = this.$route.params.name;
      switch (name) {
        case 1:
          getPosition(0);
          break;
        case 2:
          test(this.featureH);
          break;
        case 3:
          test(this.downloadH - 100);
          break;
        case 4:
          test(this.fastH - 100);
          break;
      }
      if (this.queryName === '快速报名') {
        // 判断safari浏览器
        if (
          /Safari/.test(navigator.userAgent) &&
          !/Chrome/.test(navigator.userAgent)
        ) {
          console.log('这是Safari浏览器');
          window.scrollTo(0, this.fastH - 100);
        }
        window.scrollTo(0, this.fastH - 100);
      }

      if (this.queryName === '应用下载') {
        window.scrollTo(0, this.downloadH - 100);
      }
    }
  }
};
</script>
<style lang="less">
.sign {
  height: 100vh;
  background: rgba(255, 255, 255, 1);
  ::-webkit-scrollbar {
    display: none;
  }
  .offline {
    background: rgba(255, 255, 255, 1);
    // background: olivedrab;
    .title {
      text-align: center;
      padding-top: 85px;
      font-size: 40px;
      font-weight: 800;
      font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial,
        sans-serif;
      line-height: 68px;
      color: rgba(51, 51, 51, 1);
    }
    & > .title {
      margin: 2% 0 4% 0;
    }
    .sign-icon {
      display: flex;
      justify-content: space-between;
      align-items: center;
      animation-delay: 0.5s;
      margin-top: 30px;
      display: flex;
      align-items: flex-end;

      .icon-item {
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        .name {
          font-size: 24px;
          font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial,
            sans-serif;
          font-weight: 500;
          line-height: 41px;
          color: rgba(51, 51, 51, 1);
        }
        .line {
          width: 112px;
          height: 13px;
        }
      }
    }
    .sing-swiper {
      animation-delay: 0.3s;
      .sign-container {
        background: rgba(0, 0, 0, 0.6);
      }
    }
  }
  .feature {
    height: 900px;
    background: rgba(251, 251, 251, 1);
    .title {
      text-align: center;
      padding: 200px 0 96px 0;
      font-size: 40px;
      font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial,
        sans-serif;
      font-weight: 800;
      line-height: 68px;
      color: rgba(51, 51, 51, 1);
    }
    .items {
      display: flex;
      justify-content: space-between;
      align-items: center;
      animation-delay: 0.3s;
      .item {
        height: 375px;
        opacity: 1;
        border-radius: 16px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        position: relative;
        &:hover {
          transform: translateY(-24px);
          transition-duration: 1.5s;
          transition-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 8px 16px rgba(204, 204, 204, 0.2);
          .top {
            background: rgba(246, 246, 246, 1);
          }
        }
      }
      @media screen and (min-width: 1440px) {
        .item {
          width: 24%;
        }
      }
      @media screen and (max-width: 1440px) and (min-width: 1280px) {
        .item {
          width: 25%;
        }
      }
      @media screen and (max-width: 1280px) {
        .item {
          width: 22%;
        }
      }
      .top {
        margin-top: 20px;
        width: 160px;
        height: 160px;
        background: rgba(255, 255, 255, 1);
        opacity: 1;
        border-radius: 80px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 88px;
          height: 88px;
        }
      }
      .middle {
        font-size: 28px;
        font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial,
          sans-serif;
        font-weight: 500;
        line-height: 48px;
        color: rgba(96, 98, 102, 1);
        margin: 50px 0 24px;
      }
      .bottom {
        width: 80%;
        text-align: center;
        font-size: 16px;
        font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial,
          sans-serif;
        font-weight: 400;
        line-height: 27px;
        color: rgba(144, 147, 153, 1);
        margin-bottom: 10px;
      }
    }
  }
  .download {
    background: rgba(255, 255, 255, 1);
    height: 800px;
    .title {
      font-size: 40px;
      font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial,
        sans-serif;
      font-weight: 800;
      line-height: 68px;
      color: rgba(51, 51, 51, 1);
      text-align: center;
      margin-top: 100px;
      margin-bottom: 40px;
      text-align: center;
    }
    .con {
      display: flex;
      justify-content: center;
      .left {
        flex: 1;
        height: 71%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: url(../assets/images/tel-bg.png) center no-repeat;
        margin-left: 14%;
        .tel {
          width: 366px;
          height: 694px;
          background: url(../assets/images/iphone.png) center no-repeat;
          box-shadow: rgba(255, 173, 28, 0.12);
          opacity: 1;
          border-radius: 40px;
          position: relative;
          animation-delay: 0.3s;
        }
        .panel {
          width: 278px;
          height: 496px;
          position: absolute;
          left: 45px;
          top: 90px;
          overflow: hidden;
        }
      }
    }
    .right {
      width: 40%;
      display: flex;
      flex-direction: column;
      margin-right: 11%;
      animation-delay: 0.6;
      .s-title {
        margin-top: 134px;
        font-size: 40px;
        font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial,
          sans-serif;
        font-weight: bold;
        line-height: 24px;
        color: rgba(51, 51, 51, 1);
      }
      .desc {
        margin: 40px 0 90px;
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 500;
        line-height: 40px;
        color: rgba(51, 51, 51, 1);
      }
      .ercode {
        width: 180px;
        height: 180px;
      }
    }
  }
  .fast {
    // margin: 180px auto 160px;
    padding-top: 100px;
    background: rgba(255, 255, 255, 1);
    height: 880px;

    .sign-port {
      position: relative;
      .hot {
        width: 32px;
        height: 32px;
        position: absolute;
        top: -12px;
        left: 161px;
      }
    }
    .title {
      font-size: 40px;
      font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial,
        sans-serif;
      font-weight: 800;
      line-height: 68px;
      color: rgba(51, 51, 51, 1);
      text-align: center;
      margin-bottom: 40px;
    }
    .con {
      display: flex;
      justify-content: center;
      background: url(../assets/images/tel-bg2.png) center no-repeat;
      .left {
        flex: 1;

        margin-right: 11%;
        display: flex;
        justify-content: center;
        align-items: center;
        .tel {
          animation-delay: 0.3s;
          width: 366px;
          height: 694px;
          background: url(../assets/images/iphone.png) center no-repeat;
          // border: 2px solid rgba(254, 237, 209, 1);
          box-shadow: rgba(255, 173, 28, 0.12);
          opacity: 1;
          border-radius: 40px;
          position: relative;
        }
        .panel {
          width: 278px;
          height: 496px;
          position: absolute;
          left: 45px;
          top: 90px;
          overflow: hidden;
        }
      }
    }
    .right {
      animation-delay: 0.6;
      width: 40%;
      height: 71%;
      margin-left: 17%;
      display: flex;
      flex-direction: column;
      .s-title {
        margin-top: 134px;
        font-size: 40px;
        font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial,
          sans-serif;
        font-weight: bold;
        line-height: 24px;
        color: rgba(51, 51, 51, 1);
      }
      .desc {
        margin: 40px 0 90px;
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 500;
        line-height: 40px;
        color: rgba(51, 51, 51, 1);
      }
      .ercode {
        width: 180px;
        height: 180px;
      }
    }
  }
}
</style>
